import axios from "axios";
import { resolve } from "path";
import * as crypto from "crypto";
import * as utils from './misc';

declare global {
    const Misc: typeof utils;
} declare const global: any;

// declare const global: any; // auto populate with global variable of js
// export const API_HOST = `${global["__env"].api_host}/`;
// export const API_URL = `${global["__env"].api_host}/${global["__env"].api_endpoint}`;

// export const API_HOST = `${cfg.api_host}/`;
// export const API_URL = `${cfg.api_host}/${cfg.api_endpoint}`;

// export default { API_URL, API_HOST };

/**
 * Tạo AxiosInstance
 */
function createHttp() {
    return axios.create({
        headers: { "Access-Control-Allow-Origin": "*", "Cache-Control": "no-cache" },
    });
}

/**
 * Đọc file theo đường dẫn
 * @param path
 */
// export async function readFile(path: string) {
//     return await createHttp().get(resolve("..", path));
// }

/**
 * Đọc file theo đường dẫn
 * @param path
 */
export function readFileAsync(path: string) {
    const data = createHttp()
        .get(resolve("..", path))
        .then((e) => e.data)
        .catch((error) => {
            throw error;
        });
    return data;
}

/**
 * Kiểm tra chuỗi rỗng
 * @param value
 */
export function isEmpty(value: any) {
    return value === null || value === undefined || value === "" || value.length === 0;
}

/**
 * Simple is object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item: any) {
    return item && typeof item === "object" && !Array.isArray(item) && item !== null;
}

/**
 * Deep merge two objects.
 * @param target
 * @param source
 */

/**
 * Khử dấu UTF-8
 * @param value
 */
export function noSign(value: string) {
    value = value.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    value = value.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    value = value.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    value = value.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    value = value.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    value = value.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    value = value.replace(/đ/g, "d");
    value = value.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    value = value.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    value = value.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    value = value.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    value = value.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    value = value.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    value = value.replace(/Đ/g, "D");
    return value;
}

/**
 * Trả về giá trị MD5 không mã hóa
 * @param value
 */
// export function HashMD5(value: string) {
//     return crypto.createHash("md5").update(value).digest("hex");
// }

// export const isDev = "development" === process.env.NODE_ENV;
// export const isProduct = "production" === process.env.NODE_ENV;
